import { render, staticRenderFns } from "./PrizeEdit.vue?vue&type=template&id=64a4855c&scoped=true&"
import script from "./PrizeEdit.vue?vue&type=script&lang=js&"
export * from "./PrizeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a4855c",
  null
  
)

export default component.exports